/** Shared types for the AI training / exam-corpus surface. */

export type PaperStatus =
  | 'queued'
  | 'parsing'
  | 'chunking'
  | 'embedding'
  | 'ready'
  | 'failed';

export type PaperType = 'CAT' | 'Final' | 'Re-sit' | 'Mock' | 'Other';

export interface Paper {
  id: string;
  file_name: string;
  course_id?: string;
  course_code?: string;
  course_title?: string;
  academic_session?: string;
  year?: string;
  paper_type?: PaperType;
  page_count?: number;
  chunk_count?: number;
  question_count?: number;
  status: PaperStatus;
  error?: string;
  uploaded_at?: string;
  uploaded_by?: string;
  embedding_model?: string;
}

export interface CorpusStats {
  total_papers: number;
  ready: number;
  processing: number;
  failed: number;
  total_chunks: number;
  total_questions: number;
  last_upload?: string;
}

export interface CourseOption {
  id: string;
  code: string;
  title: string;
}

export interface PendingUpload {
  id: string;
  file: File;
  course_id?: string;
  course_code?: string;
  year?: string;
  paper_type?: PaperType;
  academic_session?: string;
  progress: number;
  error?: string;
}

export const STATUS_META: Record<
  PaperStatus,
  { label: string; tw: string; dotTw: string }
> = {
  queued:    { label: 'Queued',       tw: 'bg-slate-100 text-slate-600',         dotTw: 'bg-slate-400' },
  parsing:   { label: 'Parsing PDF',  tw: 'bg-blue-50 text-[#2e86ab]',           dotTw: 'bg-[#2e86ab]' },
  chunking:  { label: 'Chunking',     tw: 'bg-blue-50 text-[#2e86ab]',           dotTw: 'bg-[#2e86ab]' },
  embedding: { label: 'Embedding',    tw: 'bg-purple-50 text-[#6c3483]',         dotTw: 'bg-[#6c3483]' },
  ready:     { label: 'Ready',        tw: 'bg-emerald-50 text-[#0e9172]',        dotTw: 'bg-[#0e9172]' },
  failed:    { label: 'Failed',       tw: 'bg-red-50 text-[#c0392b]',            dotTw: 'bg-[#c0392b]' },
};

export const formatRelative = (iso?: string): string => {
  if (!iso) return '';
  const d = new Date(iso).getTime();
  const s = Math.floor((Date.now() - d) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
